import React from 'react';
import { TypedMemo } from '../../common/types';
import { LOGO_ASPECT, LOGO_BARS, LOGO_VIEW_BOX, LOGO_WORD_PATHS } from './music24BrandPaths';

export interface Music24FullLogoProps {
  /** The height in px. The width follows the logo (about 5 times the height). */
  size?: number;
  className?: string;
  /** The accessible name. The default is "Music24". */
  label?: string;
}

/**
 * The Music24 logo: the emblem and the word "music24". The word takes the text colour
 * (`currentColor`), so one logo works on the light and the dark theme and on a photo.
 */
const Music24FullLogoComponent: React.FC<Music24FullLogoProps> = ({ size = 26, className, label = 'MUSIC24' }) => (
  <svg
    width={Math.round(size * LOGO_ASPECT * 100) / 100}
    height={size}
    viewBox={LOGO_VIEW_BOX}
    fill="none"
    className={className}
    style={{ display: 'block' }}
    role="img"
    aria-label={label}
    data-testid="music24-full-logo"
  >
    {LOGO_BARS.map((bar) => (
      <path key={bar.fill} fill={bar.fill} d={bar.d} />
    ))}
    {LOGO_WORD_PATHS.map((d) => (
      <path key={d} fill="currentColor" d={d} />
    ))}
  </svg>
);

export const Music24FullLogo = TypedMemo(Music24FullLogoComponent);
